import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { parseISO } from 'date-fns';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { formatDisplayDate, formatWeekday } from '@/utils/date';
import { toMonthParam } from '../utils/holidayCalendar';

interface HolidayDateLinkProps {
  isoDate: string;
  className?: string | undefined;
  children: ReactNode;
}

export function HolidayDateLink({ isoDate, className, children }: HolidayDateLinkProps) {
  const displayDate = `${formatWeekday(isoDate)}, ${formatDisplayDate(isoDate)}`;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Link
            to="/settings/holidays"
            search={{ month: toMonthParam(parseISO(isoDate)), date: isoDate }}
            target="_blank"
            rel="noreferrer"
          />
        }
        aria-label={`Open ${displayDate} in Holiday Calendar, opens in a new tab`}
        className={className}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent>Open in Holiday Calendar</TooltipContent>
    </Tooltip>
  );
}
